import createEntityBundle from '~/src/Lib/createEntityBundle'
import { LabType as schema } from '~/src/Store/Schemas'

export default createEntityBundle({
  name: 'labTypes',
  singularName: 'labType',
  apiConfig: { schema },
})
